import { render, staticRenderFns } from "./com-add-business.vue?vue&type=template&id=3a6b3576&"
import script from "./com-add-business.vue?vue&type=script&lang=js&"
export * from "./com-add-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports